module.exports = __webpack_public_path__ + "static/media/Leandro-Bolivar.6405fd60.png";